import { QueryClientProvider, useQueryClient } from '@tanstack/react-query';
import { ReactNode } from 'react';
import { queryClient } from '../lib/queryClient';

interface QueryProviderProps {
  children: ReactNode;
}

/**
 * Provider TanStack Query unifié pour l'application EKOSE.
 * Utilise l'instance globalement centralisée dans src/lib/queryClient.ts.
 */
export function QueryProvider({ children }: QueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export { queryClient };

/**
 * Hook utilitaire pour assurer la disponibilité du QueryClient.
 */
export function useSafeQueryClient() {
  const client = useQueryClient();
  if (!client) {
    throw new Error('useSafeQueryClient must be used within a QueryClientProvider');
  }
  return client;
}
